module.exports = __webpack_public_path__ + "img/agent-apikey.ffae6c1a.png";